import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import Glyph from 'component/utils/Glyph'
import TableArrowDown from 'component/svgComponents/tableArrowDown'
import { STATUS_TYPE } from 'constants/config'

import 'container/priceBanner/styles.css';
import Modal from 'component/Modal/GenericModal'
import ExclusionModalPriceBanner from 'component/priceBanner/general/ExclusionModalPriceBanner'
import useScrollShadow from 'utils/hooks/useScrollShadow'

const DEFAULT_ORDERS = [
  { id: "dsDynamic", active: true, direction: "ASC" },
  { id: "dsCard", active: false, direction: "ASC" },
  { id: "nuRange", active: false, direction: "ASC" },
  { id: "dtStart", active: false, direction: "ASC" },
  { id: "dtEnd", active: false, direction: "ASC" },
]

const TableParams = ({
  openModal,
  editModal,
  handleConfirmDelete,
  records,
  handleOrder,
  cdDynamicList,
  setCdDynamicList,
  translate,
  removeSelected,
  addSelectedItem,
  setSelectedItemsData,
  currentOrder,
}) => {

  const [orders, setOrders] = useState(DEFAULT_ORDERS)

  useEffect(() => {
    if (!currentOrder?.order || !currentOrder?.orderDirection) {
      setOrders(DEFAULT_ORDERS)
      return
    }

    setOrders(prevOrders => {
      const updated = prevOrders.map(order => {
        if (order.id === currentOrder.order) {
          return {
            ...order,
            active: true,
            direction: currentOrder.orderDirection,
          }
        }

        return { ...order, active: false }
      })

      return updated
    })
  }, [currentOrder?.order, currentOrder?.orderDirection])

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);

  const tableRef = useRef(null)
  const [height, setHeight] = useState(0)
  const PAGINATION_HEIGHT = 71
  const TOP_ACTIONS = 95
  const TOP_BAR = 67 + 50

  const isSelectionMode = cdDynamicList.length > 0;

  useEffect(() => {
    setHeight(window.innerHeight)
    const calculateHeight = () => {
      setHeight(window.innerHeight)
    }
    window.addEventListener("resize", calculateHeight)
    return () => window.removeEventListener("resize", calculateHeight)
  }, [])

  const changeOrder = (index) => {
    setOrders(prevOrders => {
      const clickedOrder = prevOrders[index]
      const isCurrentlyActive = clickedOrder && clickedOrder.active
      const currentDirection = clickedOrder && clickedOrder.direction
      
      const nextDirection = (isCurrentlyActive && currentDirection === "ASC") 
        ? "DESC" 
        : "ASC"

      const newOrders = prevOrders.map((order, i) => {
        if (i === index) {
          return {
            ...order,
            active: true,
            direction: nextDirection,
          }
        }
        
        return { 
          ...order, 
          active: false,
          direction: "ASC"
        }
      })

      const activeOrder = newOrders[index]
      handleOrder(activeOrder.id, activeOrder.direction)

      return newOrders
    })
  }

  useEffect(() => {

    if (height < 868 && height !== 0) {
      const responsiveHeight = height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 100)
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `${responsiveHeight}px`
    }
    else {
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `500px`
    }
  }, [height])

  const handleOpenBranchesModal = (branchesList) => {
    const uniqueBranchesList = Array.isArray(branchesList)
      ? branchesList.filter((value, index, self) => self.indexOf(value) === index)
      : branchesList;

    setModalOpen(false);

    setTimeout(() => {
      setModalData(uniqueBranchesList);
      setModalOpen(true);
    }, 10);
  };

  const renderBranches = (record) => {
    const grouped = record.branchNamesGrouped;
    const { branches } = record;

    if (Array.isArray(grouped) && grouped.length >= 5) {
      return (
        <span> {translate('price.banner.all')} </span>
      );
    }

    const regionNames = Array.isArray(grouped) ? grouped : [];
    
    const individualBranches = Array.isArray(branches) 
      ? branches.filter(b => !regionNames.includes(b.dsRegion))
      : [];
    
    const allItems = [...regionNames, ...individualBranches.map(b => formatBranchDisplay(b))];
    
    if (allItems.length === 0) {
      return "-";
    }
    
    if (allItems.length === 1) {
      return allItems[0];
    }
    
      return (
        <span
          className="clickable-green"
        onClick={() => handleOpenBranchesModal(allItems)}
        >
          {translate('customSelect.multiLabel')}
        </span>
      );
  };

  const formatBranchDisplay = (branches) => {
    if (!branches || !branches.idBranch || !branches.dsBranch) return "-";

    const id = branches.idBranch.slice(2);

    const name = branches.dsBranch
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return `${id} - ${name}`;
  };

  const formatDate = (dateString, annualRepeat = false) => {
    if (!dateString) return "-";

    const date = new Date(`${dateString}T00:00:00`);

    if (Number.isNaN(date)) return "-";

    if (annualRepeat) {
      return new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "long"
      }).format(date);
    }

    return new Intl.DateTimeFormat("pt-BR").format(date);
  };

  const renderValue = (value) => value !== null && value !== undefined && value !== "" ? value : "-";

  const renderStatus = (statusDescription) => {
    if (!statusDescription && statusDescription !== 0) return "-";
    if (typeof statusDescription === 'string') {
      return statusDescription;
    }
    if (typeof statusDescription === 'number') {
      return STATUS_TYPE[statusDescription] || '-';
    }
    return statusDescription.toString();
  };

  const renderHeader = () => {
    let checked = false
    let setAll = true
    let checkedClassName = "stock-transfer-checkbox"
    const cdDynamicListLength = cdDynamicList.length

    if (cdDynamicListLength) {
      if (cdDynamicListLength < records.length) {
        checked = true
        checkedClassName = "stock-transfer-checked-mid"
      } else {
        checked = true

        setAll = false
      }
    }



    return (
      <tr className='pictograms-tr'>
        <th
          onClick={() => {
            if (setAll) {
              const paramsIds = records.map(i => i.cdPricebannerParams);
              setCdDynamicList(paramsIds);
              if (setSelectedItemsData) {
                setSelectedItemsData(records);
              }
            } else {
              setCdDynamicList([]);
              if (setSelectedItemsData) {
                setSelectedItemsData([]);
              }
            }
          }}
          className='text-align-center'
        >
          <input checked={checked} type={"checkbox"} className={checkedClassName} />
        </th>

        <th style={{ cursor: 'pointer', width: "28%" }} onClick={() => changeOrder(0)}>
          {translate('priceBannerHistoryAdapter.dynamic')} <TableArrowDown hide={isSelectionMode} active={orders[0].active} reverse={orders[0].direction === "ASC"} />
        </th>

        <th style={{ width: "15%" }}>
          <span className="margin-right-arrow">{translate('config.pricebannerConfig.tableHeader.dsCard')}</span>
        </th>

        <th style={{ cursor: 'pointer', width: "15%" }} onClick={() => changeOrder(2)}>
          <span className="margin-right-arrow">{translate('config.pricebannerConfig.view.ranges')}</span>
          <TableArrowDown hide={isSelectionMode} active={orders[2].active} reverse={orders[2].direction === "ASC"} />
        </th>

        <th style={{ cursor: 'pointer', width: "17%" }} onClick={() => changeOrder(3)}>
          <span className="margin-right-arrow">{translate('price.banner.start')}</span>
          <TableArrowDown hide={isSelectionMode} active={orders[3].active} reverse={orders[3].direction === "ASC"} />
        </th>

        <th style={{ cursor: 'pointer', width: "17%" }} onClick={() => changeOrder(4)}>
          <span className="margin-right-arrow">{translate('price.banner.end')}</span>
          <TableArrowDown hide={isSelectionMode} active={orders[4].active} reverse={orders[4].direction === "ASC"} />
        </th>

        <th style={{ width: "20%" }}>{translate('price.banner.stores')}</th>
        <th style={{ width: "18%" }}>{translate('price.banner.params.annual.repeat')}</th>
        <th style={{ width: "12%" }}>{translate('status')}</th>
        <th style={{ width: "15%" }} className='text-align-center right-side-icons'>
          {!isSelectionMode && translate('price.banner.view')}
        </th>
        <th style={{ width: "15%" }} className='text-align-center right-side-icons'>
          {!isSelectionMode && translate('edit_button_label')}
        </th>
        <th style={{ width: "15%" }} className='text-align-center right-side-icons'>
          {!isSelectionMode && translate('config.pricebannerConfig.tableHeader.remove')}
        </th>
      </tr>
    )
  }

  const capitalizeFirstLetter = (value) => {
    if (!value || typeof value !== 'string') return '-';
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  };

  const renderBody = () => {

    const renderRecord = (record) => {
      const { cdPricebannerParams, dsCard, nuRange, dtStart, dtEnd, annualRepeat, dynamic, statusDescription } = record;

      const checked = cdDynamicList.includes(cdPricebannerParams);

      return (
        <tr className={`${checked ? 'stock-transfer-checked' : ''}`} key={cdPricebannerParams}>
          <td className='text-align-center'>
            <input
              type="checkbox"
              className="stock-transfer-checkbox"
              checked={checked}
              onChange={() => {
                if (checked) {
                  removeSelected(cdPricebannerParams);
                } else {
                  if (addSelectedItem) {
                    addSelectedItem(record);
                  } else {
                    setCdDynamicList([...cdDynamicList, cdPricebannerParams]);
                  }
                }
              }}
            />
          </td>

          <td style={{ width: "28%" }}> {dynamic.dsDynamic || "-"}</td>
          <td style={{ width: "15%" }}>{dsCard ? capitalizeFirstLetter(dsCard) : "-"}</td>
          <td style={{ width: "15%" }}>{renderValue(nuRange)}</td>

          <td style={{ width: "17%" }}>{formatDate(dtStart, annualRepeat)}</td>
          <td style={{ width: "17%" }}>{formatDate(dtEnd, annualRepeat)}</td>

          <td style={{ width: "20%" }}>{renderBranches(record)}</td>
          <td style={{ width: "18%" }}> {annualRepeat ? translate('priceBannerFragment.optionYes') : translate('priceBannerFragment.optionNo')}</td>
          <td style={{ width: "12%" }}>{renderStatus(statusDescription)}</td>
          <td style={{ width: "15%" }} className='mission-block-edit-icon'>
            {!isSelectionMode && (
              <Glyph
                type='eye'
                color='primary'
                onClick={() => openModal(record)}
              />
            )}
          </td>

          <td style={{ width: "15%" }} className='mission-block-edit-icon'>
            {!isSelectionMode && (
              <Glyph
                type='pencil'
                color='primary'
                onClick={() => editModal(record)}
              />
            )}
          </td>

          <td style={{ width: "15%" }} className='mission-block-edit-icon'>
            {!isSelectionMode && (
              <ExclusionModalPriceBanner
                t={translate}
                title={translate('price.banner.params.delete')}
                dynamicName={record.dynamic?.dsDynamic}
                onConfirm={() => handleConfirmDelete(record.cdPricebannerParams)}
                confirmButtonMsg={translate('missionMenu.removeModal.ok')}
                cancelButtonMsg={translate('close_button_label')}
                size="sm"
                renderButton={({ onClick }) => (
                  <i
                    onClick={onClick}
                    className='color-danger glyph glyph-trash-can icon-size pictogram-trash-icon'
                    style={{ cursor: 'pointer' }}
                    aria-label={translate('price.banner.delete')}
                  />
                )}
              />
            )}
          </td>

        </tr>
      )
    }

    return records.map(renderRecord)
  }

  useScrollShadow(
    [modalOpen, modalData], 
    modalOpen ? '.branches-modal .custom-modal-content' : null
  )

  const renderModal = () => {
    if (!modalOpen) return null;

    return (
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title={translate('price.banner.stores')}
        confirmButtonText={(translate('close_button_label'))}
        hideCancelButton={true}
        className="branches-modal"
      >
        <ul>
          {modalData.map((item, index) => (
            <li key={index} style={{ marginBottom: '4px' }}>{item}</li>
          ))}
        </ul>
      </Modal>
    );
  };

  return (
    <>
      <table cellPadding={0} cellSpacing={0} className={`mission-block-table-new new pictograms-table ${cdDynamicList.length ? 'pictograms-check-mode' : ''}`}>
        <thead ref={tableRef}>{renderHeader()}</thead>
        <tbody className='tbody-mission-block'
          onScroll={(e) => {
            if (e.currentTarget.scrollTop > 20) {
              tableRef.current.classList.add("shadow-table-header-mission-block")
            }
            else {
              tableRef.current.classList.remove("shadow-table-header-mission-block")
            }
          }}
        >
          {renderBody()}
        </tbody>
      </table>
      {renderModal()}
    </>
  )
}

TableParams.propTypes = {
  cdDynamicList: PropTypes.array.isRequired,
  editModal: PropTypes.func,
  handleConfirmDelete: PropTypes.func.isRequired,
  handleResize: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  setCdDynamicList: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  removeSelected: PropTypes.func.isRequired,
  addSelectedItem: PropTypes.func,
  setSelectedItemsData: PropTypes.func,
  handleOrder: PropTypes.func.isRequired,
  currentOrder: PropTypes.shape({
    order: PropTypes.string,
    orderDirection: PropTypes.string,
  }),
}

export default TableParams
